export default "__VITE_ASSET__7dbd2016__"